import { Route as RRDRoute, Redirect as RRDRedirect } from 'react-router-dom'
import { isAuthenticated } from '../../../services/Auth'
import { routesConfig } from '../../configs/routes'
export function Route({ component: Component, children, ...args }: any) {
  if (isAuthenticated() && args.path === routesConfig.auth.login)
    return <RRDRedirect to={routesConfig.home} />

  if (!isAuthenticated() && args.private)
    return <RRDRedirect to={routesConfig.auth.login} />

  if (args.redirect) return <RRDRedirect to={args.redirect} />

  return (
    <RRDRoute component={Component} {...args}>
      {children}
    </RRDRoute>
  )
}

Route.defaultProps = {
  privateRoute: false
}

export default Route
